/* VIEDeFLAMME – kleine Helfer, kein Framework. */
(function () {
  // Mobile Navigation
  var knopf = document.querySelector('.menue-knopf');
  var nav = document.querySelector('.kopf nav');
  if (knopf && nav) {
    knopf.addEventListener('click', function () {
      var offen = nav.classList.toggle('offen');
      knopf.setAttribute('aria-expanded', String(offen));
    });
  }

  // Warenkorbzahl nach AJAX-Hinzufügen aktualisieren
  window.vdfKorbZahl = function (anzahl) {
    document.querySelectorAll('[data-korb-zahl]').forEach(function (el) {
      el.textContent = anzahl;
    });
  };
})();
